import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType as NewEventType } from '@/features/events/types/EventType';
import { Question } from '@/utils/api-objects/Question';
import { saveEvent } from '@/utils/apis/user-service';
import { EventType } from '@/utils/enums/EventType';
import { useAuthStore } from '@/utils/stores/useAuthStore';
import { useUserStore } from '@/utils/stores/useUserStore';

export const useSurveyEvents = () => {
    const { sendEvent } = useCreateEvent();
    const { auth } = useAuthStore();
    const { userData } = useUserStore();

    const trackPageView = async () => {
        if (!userData.email || !auth.idToken) return;

        await saveEvent(
            userData.email,
            EventType.PageView,
            () => {},
            (error) => console.log(error),
            "health_assessment_questions_page"
        );

        await sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "health_assessment_questions_page",
        });
    };

    const trackAnswerSubmission = async (question: Question) => {
        if (!userData.email || !auth.idToken) return;

        await saveEvent(
            userData.email,
            `submit_answer_${question.id}_button_clicked`,
            () => {},
            (error) => console.log(error),
            "health_assessment_questions_page"
        );

        await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: { action: "save_answer", question: question.id }
        });
    };

    const trackSurveyCompletion = async (responses: Map<string, Set<string>>) => {
        if (!userData.email || !auth.idToken) return;

        await saveEvent(
            userData.email,
            "health_assessment_completed",
            () => {},
            (error) => console.log(error),
            "health_assessment_questions_page"
        );

        await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "survey_completed",
            event_metadata: { 
                action: "complete_health_assessment",
                total_questions: responses.size,
                completed_at: new Date().toISOString()
            }
        });
    };

    return {
        trackPageView,
        trackAnswerSubmission,
        trackSurveyCompletion
    };
}; 